
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function Hero() {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleWatchStory = () => {
    setShowVideoModal(true);
  };

  const handleSearchFlights = () => {
    // Scroll to deals section instead since search form is removed
    const dealsSection = document.querySelector('section');
    if (dealsSection) {
      dealsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=modern%20commercial%20airplane%20flying%20above%20clouds%20at%20sunset%2C%20beautiful%20aviation%20scene%20with%20golden%20lighting%2C%20aircraft%20soaring%20through%20dramatic%20sky%2C%20professional%20flight%20photography%2C%20inspiring%20travel%20destination%20background%2C%20peaceful%20aerial%20view%20with%20orange%20and%20blue%20gradient%20sky&width=1920&height=1080&seq=hero-flight&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="inline-flex items-center px-6 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-semibold mb-6">
              <i className="ri-award-line mr-2"></i>
              India's #1 Flight Booking Platform
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              Fly Anywhere,
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-pink-600">
                Pay Less
              </span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto leading-relaxed">
              Book domestic and international flights at unbeatable prices. Guaranteed lowest rates, instant confirmations, and 24/7 support for all your travel needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button 
                size="lg" 
                className="bg-gradient-to-r from-orange-500 to-pink-600 hover:from-orange-600 hover:to-pink-700"
                onClick={handleSearchFlights}
              >
                <i className="ri-flight-takeoff-line mr-2"></i>
                View Flight Deals
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="text-white border-white hover:bg-white hover:text-gray-900"
                onClick={handleWatchStory}
              >
                <i className="ri-play-circle-line mr-2"></i>
                Watch Our Story
              </Button>
            </div>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold mb-2">500+</div>
                <div className="text-gray-300">Airlines Worldwide</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">1M+</div>
                <div className="text-gray-300">Flights Booked</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">50,000+</div>
                <div className="text-gray-300">Happy Travelers</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-2">24/7</div>
                <div className="text-gray-300">Customer Support</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative max-w-4xl w-full mx-4">
            <button
              onClick={() => setShowVideoModal(false)}
              className="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center text-white hover:text-gray-300 cursor-pointer"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            
            <div className="bg-black rounded-lg overflow-hidden shadow-2xl">
              <div className="relative aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/6stlCkUDG_s?autoplay=1&rel=0&modestbranding=1"
                  title="MaxJourneys - Our Story"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              
              <div className="p-6 bg-white">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">The MaxJourneys Story</h3>
                <p className="text-gray-700 mb-4">
                  Discover how MaxJourneys became India's most trusted flight booking platform. From revolutionizing online flight bookings to serving over 1 million passengers, watch our journey of innovation, trust, and creating seamless travel experiences.
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 text-sm text-gray-600">
                    <span className="flex items-center">
                      <i className="ri-time-line mr-1"></i>
                      3:42 minutes
                    </span>
                    <span className="flex items-center">
                      <i className="ri-eye-line mr-1"></i>
                      25,384 views
                    </span>
                  </div>
                  <button
                    onClick={() => setShowVideoModal(false)}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg cursor-pointer whitespace-nowrap transition-colors"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}